import { render, staticRenderFns } from "./addBankName.vue?vue&type=template&id=173711a6&scoped=true&"
import script from "./addBankName.vue?vue&type=script&lang=ts&"
export * from "./addBankName.vue?vue&type=script&lang=ts&"
import style0 from "./addBankName.vue?vue&type=style&index=0&id=173711a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173711a6",
  null
  
)

export default component.exports